// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"500eeeec340ecbfd","9239":"87a8bdc06f131293"}[chunkId] + ".css";
};